import { appendElement } from '../xml-helpers';

export function buildPages(
  parent: Element,
  firstPageNumber: string | undefined
): void {
  if (firstPageNumber) {
    const pages = appendElement(parent, 'pages');
    appendElement(pages, 'first_page', firstPageNumber);
  }
}
